import { DEFAULT_QUOTATION_TEMPLATE_DEFINITION, type QuotationScopeCatalogueSection, type QuotationTemplateDefinition } from '@/constants/quotationOptions';

export const ADDITIONAL_SCOPE_SECTION_KEY = 'additionalSiteFeatures';

/** Optional catalogue choices are available for every project type, not automatically quoted. */
export function withQuotationAdditionalScope(
  sections: QuotationScopeCatalogueSection[],
  template: Pick<QuotationTemplateDefinition, 'scopeSections'>,
): QuotationScopeCatalogueSection[] {
  if (sections.some(section => section.key === ADDITIONAL_SCOPE_SECTION_KEY)) return sections;
  const additional = template.scopeSections.find(section => section.key === ADDITIONAL_SCOPE_SECTION_KEY)
    || DEFAULT_QUOTATION_TEMPLATE_DEFINITION.scopeSections.find(section => section.key === ADDITIONAL_SCOPE_SECTION_KEY)!;
  return [...sections, { ...additional, bullets: [...additional.bullets] }];
}
